module.exports = __webpack_public_path__ + "static/media/girini_welkom.cad82b9a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/girini_welkom.mp3
// module id = 186
// module chunks = 0